export default "__VITE_ASSET__CUL08KIN__"